module.exports = __webpack_public_path__ + "img/logo-company.aaebafb6.png";